













import { defineComponent, watch, computed, toRefs } from '@vue/composition-api';
import { PropType } from 'vue';
import { MessageBox } from 'byted-vui';
import { CommentStatus, AdgroupFormData, CampaignFormData, AdgroupConfig } from '@tt4b/ttam-enums';
import placementComment from './index';
import { i18n } from './../../../i18n';
import { trackEvent } from './../../../utils/index';

const name = 'ttam-placement-comment-compose';

export default defineComponent({
  name,
  components: {
    TtamPlacementCommentSwitch: placementComment.TtamPlacementCommentSwitch,
    TtamPlacementCommentSwitchTips: placementComment.TtamPlacementCommentSwitchTips,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
      required: true,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
      required: true,
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      required: true,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, adgroupConfig } = toRefs(props);

    const _commentStatus = computed({
      get: () => props.adgroupData.isCommentDisable,
      set: v => emit('change', v),
    });

    const { disabled: commentDisabled } = placementComment.useSwitchPropsDisabled({
      adgroupConfig,
    });
    const { visible: commentVisible } = placementComment.useSwitchPropsVisible({
      adgroupData,
      campaignData,
    });

    // 不可见的时候，重置value，触发emit，通知外层修改
    watch(
      commentVisible,
      newVal => {
        if (!newVal) {
          _commentStatus.value = CommentStatus.ENABLE;
        }
      },
      {
        immediate: true,
      },
    );

    const onCommentStatusChange = async v => {
      if (v === CommentStatus.DISABLE) {
        try {
          await MessageBox.confirm(
            i18n.t('comment_management_message_box_desc') as string,
            i18n.t('comment_management_message_box_title') as string,
            {
              distinguishCancelAndClose: true,
              confirmButtonText: i18n.t('comment_management_message_keep_open') as string,
              cancelButtonText: i18n.t('comment_close') as string,
            },
          );

          trackEvent('cmt_popup_keepon', {
            cmt_popup_keepon: 1,
          });
        } catch (action) {
          if (action === 'cancel') {
            _commentStatus.value = CommentStatus.DISABLE;
            trackEvent('cmt_popup_turnoff');
          } else {
            trackEvent('cmt_popup_keepon', {
              cmt_popup_keepon: 2,
            });
          }
        } finally {
          trackEvent('cmt_popup_show');
        }
      } else {
        _commentStatus.value = CommentStatus.ENABLE;
      }
    };

    return {
      _commentStatus,
      commentDisabled,
      commentVisible,
      onCommentStatusChange,
    };
  },
});
